import React, { useState, useEffect } from 'react';
import PageTitle from '../shared/PageTitle';
import { useSettings } from '../../contexts/SettingsContext';
import { noticeAPI } from '../../services/api';

// Generate dynamic styles for maintenance rules
const generateRulesStyles = (settings) => `
  .maintenance-rules .card-header {
    background-color: ${settings.block_title_bg_color || '#f8f9fa'} !important;
    color: ${settings.block_title_color || '#212529'} !important;
  }
  
  .maintenance-rules .card-header h5 {
    color: ${settings.block_title_color || '#212529'} !important;
    margin: 0 !important;
  }
  
  .maintenance-rules .card {
    background-color: ${settings.card_bg_color || '#ffffff'} !important;
  }
  
  .maintenance-rules .card-body {
    background-color: ${settings.card_bg_color || '#ffffff'} !important;
    color: ${settings.text_color || '#212529'} !important;
  }
  
  /* .maintenance-rules .alert-info {
    background-color: ${settings.btn_info_bg || '#d1ecf1'} !important;
    color: ${settings.btn_info_text || '#0c5460'} !important;
    border-color: ${settings.btn_info_bg || '#bee5eb'} !important;
  } */
`;

const MaintenanceRules = () => {
  const { settings } = useSettings();
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Inject custom styles for maintenance rules
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.id = 'maintenance-rules-styles';
    styleElement.innerHTML = generateRulesStyles(settings);
    document.head.appendChild(styleElement);

    return () => {
      const existingStyle = document.getElementById('maintenance-rules-styles');
      if (existingStyle) {
        existingStyle.remove();
      }
    };
  }, [settings]);

  useEffect(() => {
    const fetchRules = async () => {
      try {
        const response = await noticeAPI.getRules();
        setRules(response.data);
      } catch (err) {
        console.error('Error fetching rules:', err);
        setError('Failed to load rules.');
      } finally {
        setLoading(false);
      }
    };
    fetchRules();
  }, []);

  if (loading) {
    return (
      <div className="maintenance-rules container-fluid mt-4">
        <PageTitle icon="fa-gavel" title="Rules" />
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="maintenance-rules container-fluid mt-4">
        <PageTitle icon="fa-gavel" title="Rules" />
        <div className="alert alert-danger">
          <i className="fas fa-exclamation-circle me-2"></i>
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="maintenance-rules container-fluid mt-4">
      <PageTitle icon="fa-gavel" title="Society Rules" />
      {rules.length === 0 ? (
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          No rules have been published yet.
        </div>
      ) : (
        <div className="card shadow">
          <div className="card-header bg-primary text-white">
            <h5 className="mb-0">
              <i className="fas fa-gavel me-2"></i>
              Society Rules & Regulations
            </h5>
          </div>
          <div className="card-body p-0">
            <ul className="list-group list-group-flush">
              {rules.map((rule, index) => (
                <li key={rule.id} className="list-group-item border-bottom">
                  <div className="d-flex align-items-start">
                    <div className="badge bg-secondary me-3 mt-1 fw-bold">
                      {index + 1}
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="mb-2 text-primary">{rule.title}</h5>
                      <p className="mb-1 text-dark">{rule.description}</p>
                      {rule.created_at && (
                        <small className="text-muted">
                          <i className="fas fa-calendar-alt me-1"></i>
                          Published: {new Date(rule.created_at).toLocaleDateString()}
                        </small>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="card-footer text-muted text-center">
            <small>
              <i className="fas fa-info-circle me-2"></i>
              Please ensure all rules and regulations are followed for the safety and wellbeing of all residents.
            </small>
          </div>
        </div>
      )}
    </div>
  );
};

export default MaintenanceRules; 